"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _lodash = require("lodash");
var _color = _interopRequireDefault(require("./styles/color"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _PasswordHelperCard = _interopRequireDefault(require("./PasswordHelperCard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var ParentContainer = _styledComponents["default"].div.withConfig({
  displayName: "ParentContainer",
  componentId: "sc-1b2sg27-0"
})(["display:grid;position:relative;"]);
var PasswordHelperCardContainer = _styledComponents["default"].div.withConfig({
  displayName: "PasswordHelperCardContainer",
  componentId: "sc-1b2sg27-1"
})(["justify-self:center;margin-top:10px;position:absolute;"]);
var PasswordContainer = _styledComponents["default"].div.withConfig({
  displayName: "PasswordContainer",
  componentId: "sc-1b2sg27-2"
})(["display:grid;justify-self:center;"]);
var PasswordItem = _styledComponents["default"].div.withConfig({
  displayName: "PasswordItem",
  componentId: "sc-1b2sg27-3"
})(["width:320px;grid-area:item;align-self:center;justify-self:center;background-color:", ";border:2px solid ", ";height:auto;padding:20px;display:grid;grid-template-columns:auto 1fr;grid-template-areas:\"requirement infoIcon\";@media (max-width:370px){width:300px;}"], _color["default"].white, function (props) {
  return props.validPassword ? _color["default"].success : _color["default"].danger;
});
/**
 * Set 0px for margin, something coming from styled components
 * We can make our own margin isntead.
 */
var Paragraph = _styledComponents["default"].h3.withConfig({
  displayName: "Paragraph",
  componentId: "sc-1b2sg27-4"
})(["background-color:", ";grid-area:text;font-family:Raleway,sans-serif;font-weight:400;font-size:16px;color:", ";letter-spacing:0.27px;line-height:19px;-webkit-margin-before:0;-webkit-margin-after:0;-webkit-margin-start:0;-webkit-margin-end:0;padding:0 10px;align-self:center;justify-self:left;"], _color["default"].white, function (props) {
  return props.valid ? _color["default"].success : _color["default"].danger;
});
var CheckContainer = _styledComponents["default"].div.withConfig({
  displayName: "CheckContainer",
  componentId: "sc-1b2sg27-5"
})(["grid-area:check;justify-self:center;align-self:center;padding:5px 0;margin-top:10px;svg{margin-bottom:10px;}"]);
var PasswordListContainer = _styledComponents["default"].div.withConfig({
  displayName: "PasswordListContainer",
  componentId: "sc-1b2sg27-6"
})(["grid-area:requirement;display:grid;width:246px;height:inherit;grid-template-columns:1fr;grid-template-rows:repeat(5,1fr);grid-template-areas:\"test\";.grid-parent{display:grid;grid-template-columns:40px 206px;grid-template-areas:\"check text\";}@media (max-width:370px){width:220px;}"]);
var InfoIconContainer = _styledComponents["default"].div.withConfig({
  displayName: "InfoIconContainer",
  componentId: "sc-1b2sg27-7"
})(["grid-area:infoIcon;text-align:right;height:32px;"]);
ParentContainer.displayName = 'ParentContainer';
PasswordHelperCardContainer.displayName = 'PasswordHelperCardContainer';
PasswordContainer.displayName = 'PasswordContainer';
PasswordItem.displayName = 'PasswordItem';
Paragraph.displayName = 'Paragraph';
CheckContainer.displayName = 'CheckContainer';
PasswordListContainer.displayName = 'PasswordListContainer';
InfoIconContainer.displayName = 'InfoIconContainer';
var RequirementSteps = /*#__PURE__*/function (_Component) {
  _inherits(RequirementSteps, _Component);
  var _super = _createSuper(RequirementSteps);
  function RequirementSteps(props) {
    var _this;
    _classCallCheck(this, RequirementSteps);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "displayHelper", function () {
      _this.setState({
        shouldDisplayPasswordHelper: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "dismissHelper", function () {
      _this.setState({
        shouldDisplayPasswordHelper: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "validatePassword", function (password) {
      var _this$props$messages = _this.props.messages,
        eightChars = _this$props$messages.eightChars,
        upperCase = _this$props$messages.upperCase,
        lowerCase = _this$props$messages.lowerCase,
        number = _this$props$messages.number,
        specialChar = _this$props$messages.specialChar;

      // noinspection RegExpDuplicateCharacterInClass
      var specialCharacterRegex = /[#,?,!,@,$,%,^,&,*,-]/;
      var eightOrMoreRegex = /^.{8,}$/;
      var capitalLetterRegex = /^(?=.*[A-Z]).*$/;
      var lowerLetterRegex = /^(?=.*[a-z]).*$/;
      var numberRegex = /[0-9]/;
      var metRequirements = [{
        valid: eightOrMoreRegex.test(password),
        message: eightChars
      }, {
        valid: capitalLetterRegex.test(password),
        message: upperCase
      }, {
        valid: lowerLetterRegex.test(password),
        message: lowerCase
      }, {
        valid: numberRegex.test(password),
        message: number
      }, {
        valid: specialCharacterRegex.test(password),
        message: specialChar
      }];
      var validPassword = (0, _lodash.every)(metRequirements, 'valid');
      _this.setState({
        metRequirements: metRequirements,
        validPassword: validPassword
      });
      if (_this.props.onUpdate && (0, _lodash.isFunction)(_this.props.onUpdate)) {
        _this.props.onUpdate(validPassword);
      }
    });
    var messages = props.messages;
    var defaultRequirements = [{
      valid: false,
      message: messages.eightChars
    }, {
      valid: false,
      message: messages.upperCase
    }, {
      valid: false,
      message: messages.lowerCase
    }, {
      valid: false,
      message: messages.number
    }, {
      valid: false,
      message: messages.specialChar
    }];
    _this.state = {
      metRequirements: defaultRequirements,
      validPassword: false,
      shouldDisplayPasswordHelper: false
    };
    return _this;
  }
  _createClass(RequirementSteps, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      if (this.props.validateOnMount) {
        this.validatePassword(this.props.password);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.password !== prevProps.password) {
        this.validatePassword(this.props.password);
      }
    }
  }, {
    key: "getPasswordHelperCard",
    value: function getPasswordHelperCard() {
      var _this$props$messages2 = this.props.messages,
        specialCharacter = _this$props$messages2.specialCharacter,
        numberCharacter = _this$props$messages2.numberCharacter,
        alphaCharacter = _this$props$messages2.alphaCharacter;
      var shouldDisplayPasswordHelper = this.state.shouldDisplayPasswordHelper;
      if (shouldDisplayPasswordHelper) {
        return /*#__PURE__*/_react["default"].createElement(_PasswordHelperCard["default"], {
          onClose: this.dismissHelper,
          messages: {
            specialCharacter: specialCharacter,
            numberCharacter: numberCharacter,
            alphaCharacter: alphaCharacter
          }
        });
      } else {
        return null;
      }
    }
  }, {
    key: "getPasswordListContainer",
    value: function getPasswordListContainer() {
      var metRequirements = this.state.metRequirements;
      return /*#__PURE__*/_react["default"].createElement(PasswordListContainer, null, (0, _lodash.map)(metRequirements, function (metRequirement) {
        var icon = 'x';
        var fillColor = _color["default"].danger;
        if (metRequirement.valid === true) {
          icon = 'check';
          fillColor = _color["default"].success;
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "grid-parent",
          key: metRequirement.message
        }, /*#__PURE__*/_react["default"].createElement(CheckContainer, {
          "data-cy": "check"
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          iconName: icon,
          size: "2x",
          color: fillColor
        })), /*#__PURE__*/_react["default"].createElement(Paragraph, {
          valid: metRequirement.valid
        }, metRequirement.message));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var displayValidator = this.props.displayValidator;
      if (!displayValidator) {
        return null;
      }
      var passwordHelperCard = this.getPasswordHelperCard();
      var passwordRequirementList = this.getPasswordListContainer();
      return /*#__PURE__*/_react["default"].createElement(ParentContainer, null, /*#__PURE__*/_react["default"].createElement(PasswordHelperCardContainer, null, passwordHelperCard), /*#__PURE__*/_react["default"].createElement(PasswordContainer, null, /*#__PURE__*/_react["default"].createElement(PasswordItem, {
        validPassword: this.state.validPassword
      }, /*#__PURE__*/_react["default"].createElement(InfoIconContainer, {
        "data-cy": "passwordHelperCardinfoIcon",
        onClick: this.displayHelper
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        iconName: "info",
        color: _color["default"].info,
        size: "2x"
      })), passwordRequirementList)));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return RequirementSteps;
}(_react.Component);
var _default = RequirementSteps;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(ParentContainer, "ParentContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/RequirementSteps.js");
  reactHotLoader.register(PasswordHelperCardContainer, "PasswordHelperCardContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/RequirementSteps.js");
  reactHotLoader.register(PasswordContainer, "PasswordContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/RequirementSteps.js");
  reactHotLoader.register(PasswordItem, "PasswordItem", "/Users/crs/WebstormProjects/michelangelo/src/Components/RequirementSteps.js");
  reactHotLoader.register(Paragraph, "Paragraph", "/Users/crs/WebstormProjects/michelangelo/src/Components/RequirementSteps.js");
  reactHotLoader.register(CheckContainer, "CheckContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/RequirementSteps.js");
  reactHotLoader.register(PasswordListContainer, "PasswordListContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/RequirementSteps.js");
  reactHotLoader.register(InfoIconContainer, "InfoIconContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/RequirementSteps.js");
  reactHotLoader.register(RequirementSteps, "RequirementSteps", "/Users/crs/WebstormProjects/michelangelo/src/Components/RequirementSteps.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/RequirementSteps.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();